'use client';

import { useLivePaths } from '@/context/LiveNavContext';
import { filterLiveLinks } from '@/lib/live-nav';

// Renders children only once `href` is a live page — lets a server component
// hide a CTA that points at a page not launched yet, without a 404 link.
export default function LiveOnly({ href, children }) {
  const livePaths = useLivePaths();
  return filterLiveLinks([{ href }], livePaths).length ? children : null;
}
